<div *ngIf="display" class="{{ class }}">
  <mat-spinner [diameter]="diameter"></mat-spinner>
  <h4 class="spinner-message">{{ messageToDisplay }}</h4>
</div>
